var map = {
	"./guild.json": 13295,
	"./items.json": 13857,
	"./lendingMessage.json": 2105,
	"./notificationMessage.json": 40660,
	"./specialRace.json": 96194,
	"i18n/en/guild.json": 13295,
	"i18n/en/items.json": 13857,
	"i18n/en/lendingMessage.json": 2105,
	"i18n/en/notificationMessage.json": 40660,
	"i18n/en/specialRace.json": 96194
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1839;